import { createContext } from "react";
import { WhatsappAgentModel } from "@jugl-web/rest-api/integrations/models";

export interface WhatsappAccountContextType {
  // WhatsApp Account state
  whatsappAgent: WhatsappAgentModel | undefined | null;
  isConnected: boolean;

  // Account connection functions
  connectWhatsappAccount: () => Promise<void>;
  reconnectWhatsappAccount: () => Promise<void>;

  // Connection states
  isLoginInProgress: boolean;
  isCreatingAccount: boolean;
  isRegisteringAccount: boolean;
}

export const WhatsappAccountContext = createContext<WhatsappAccountContextType>(
  {
    whatsappAgent: undefined,
    isConnected: false,

    connectWhatsappAccount: async () => {},
    reconnectWhatsappAccount: async () => {},

    isLoginInProgress: false,
    isCreatingAccount: false,
    isRegisteringAccount: false,
  }
);
